var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component, createRef, forwardRef } from 'react';
import ResizeDetector from './ResizeDetector';
function withResizeDetector(ComponentInner, options = {}) {
    class ResizeDetectorHOC extends Component {
        constructor() {
            super(...arguments);
            this.ref = createRef();
        }
        render() {
            const _a = this.props, { forwardedRef } = _a, rest = __rest(_a, ["forwardedRef"]);
            const targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (<ResizeDetector {...options} targetRef={targetRef}>
                    <ComponentInner targetRef={targetRef} ref={forwardedRef} {...rest}/>
                </ResizeDetector>);
        }
    }
    function forwardRefWrapper(props, ref) {
        return <ResizeDetectorHOC {...props} forwardedRef={ref}/>;
    }
    const name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = `withResizeDetector(${name})`;
    return forwardRef(forwardRefWrapper);
}
export default withResizeDetector;
